var map = {
	"./00-fish-bike.webp": 117,
	"./01_whale_m.webp": 118,
	"./02_ice_m.webp": 119,
	"./03_bath_m.webp": 120,
	"./04_galago_m.webp": 121,
	"./05_cosmos_m.webp": 122,
	"./06_eye_m.webp": 123,
	"./07_jewellery_m.webp": 124,
	"./08_meow_m.webp": 125,
	"./09_croco_m.webp": 126,
	"./10_papugi_m.webp": 127,
	"./11_whale_m.webp": 128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 116;